import React from 'react';
import { Card, CardContent, Typography, CardActionArea } from '@mui/material';

const DishCard = ({ dish, onDishClick }) => {
  return (
    <Card sx={{ maxWidth: 345, margin: 1 }}>
      <CardActionArea onClick={() => onDishClick(dish)}>
        <CardContent>
          <Typography variant="h6">{dish.name}</Typography>
          <Typography variant="body2" color="text.secondary">
            {dish.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default DishCard;